module.exports = __webpack_public_path__ + "static/media/Myself2.63d419e6.jpeg";